export default __webpack_public_path__ + "static/media/globe-share.7bc6d53c.png";